import { BaseWallet } from "ethers-v6";

/**
 * Verifies that a provided signer is valid and properly configured.
 * Checks for address accessibility and provider connection.
 *
 * @param {BaseWallet} signer - The ethers v6 signer to verify
 *
 * @returns {Promise<BaseWallet>} The verified signer
 * @throws {Error} If signer is invalid, missing, or not properly configured:
 *   - "No signer provided" - If signer is undefined/null
 *   - "Could not get signer address" - If signer address is inaccessible
 *   - "Signer is not connected to a provider" - If signer lacks provider
 */
export const verifySigner = async (signer) => {
  if (!signer) {
    throw new Error(`Verify Signer: No signer provided!`);
  }

  try {
    const address = await signer.getAddress();

    if (!address) {
      throw new Error("Verify Signer: Could not get signer address!");
    }

    // Verify the provider connection
    const provider = signer.provider;
    if (!provider) {
      throw new Error("Verify Signer: Signer is not connected to a provider!");
    }

    return signer;
  } catch (error) {
    throw error;
  }
};
